/*
 * stk-checkout.js — Stickerogy custom cart + Shiprocket + progress bar logic
 * Built: 2026-05-28 — Claude perf migration from inline theme.liquid scripts
 *
 * Replaces 5 inline <script> blocks that were render-blocking the <head>:
 *   - Block A: Timezone-based checkout button visibility (was lines 27-54 of theme.liquid)
 *   - Block B: Shiprocket button state from cart total + checkoutWithPriceCheck (was lines 55-166)
 *   - Block C: Shiprocket close-on-cart-change + buyCart hook with live validation (was lines 545-644)
 *   - Block D: Cart drawer free-gift/free-delivery progress bar (was lines 661-749)
 *
 * Loaded via <script defer> at end of <body> — does NOT block render.
 * Each function does its own existence check, so it's a no-op on pages
 * that don't have Shiprocket buttons or cart-drawer.
 */
(function () {
  'use strict';

  // ============================================================
  // BLOCK A — Show/hide checkout button based on India timezone
  // ============================================================
  function setCheckoutButtonVisibility() {
    var indiaTimezones = ['Asia/Kolkata', 'Asia/Calcutta'];
    var userTz;
    try { userTz = Intl.DateTimeFormat().resolvedOptions().timeZone; }
    catch (e) { userTz = ''; }
    var isIndia = indiaTimezones.indexOf(userTz) !== -1;

    var css = isIndia
      ? 'button[name="checkout"]{display:none !important;}'
        + '.shopify-payment-button__button.shopify-payment-button__button--unbranded{display:none !important;}'
      : '.shiprocket-headless{display:none !important;}';

    var styleEl = document.createElement('style');
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  // ============================================================
  // BLOCK B — Shiprocket button state from cart total
  // ============================================================
  var MIN_ORDER_PAISE = 24900; // ₹249

  function updateCheckoutButtonState(cartTotal) {
    var btn = document.querySelector('.sr-headless-checkout');
    var warn = document.getElementById('chk');
    var priceInput = document.getElementById('shiprocketCheckoutPriceCheck');
    if (priceInput) priceInput.value = cartTotal;
    if (btn) {
      if (cartTotal >= MIN_ORDER_PAISE) {
        btn.removeAttribute('disabled');
        btn.style.opacity = '1';
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.style.opacity = '0.5';
      }
    }
    if (warn) {
      warn.style.display = cartTotal >= MIN_ORDER_PAISE ? 'none' : 'block';
    }
  }

  function fetchAndUpdateCart() {
    // Browser cache OK here — cart drawer fires its own cart:updated event when items change
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCheckoutButtonState(cart.total_price); })
      .catch(function () { /* silent */ });
  }

  // Wait for Shiprocket-injected DOM, then update once
  function waitForShiprocketAndUpdate() {
    var maxWait = 5000, interval = 100, elapsed = 0;
    var timer = setInterval(function () {
      elapsed += interval;
      var btn = document.querySelector('.sr-headless-checkout');
      var warn = document.getElementById('chk');
      if (btn && warn) {
        clearInterval(timer);
        fetchAndUpdateCart();
      } else if (elapsed >= maxWait) {
        clearInterval(timer);
      }
    }, interval);
  }

  // checkoutWithPriceCheck — exposed globally for inline onclick handlers in cart pages
  window.checkoutWithPriceCheck = function () {
    var btn = document.querySelector('.sr-headless-checkout');
    var originalText = btn ? btn.innerHTML : null;
    if (btn) {
      btn.setAttribute('disabled', 'disabled');
      btn.style.opacity = '0.7';
      btn.innerHTML = 'Checking...';
    }
    // cache:'no-store' KEPT HERE — this is the click-time live validation; stale data here = lost orders
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var live = cart.total_price;
        var input = document.getElementById('shiprocketCheckoutPriceCheck');
        if (input) input.value = live;
        var chk = document.getElementById('chk');
        if (chk) chk.style.display = live >= MIN_ORDER_PAISE ? 'none' : 'block';

        if (live >= MIN_ORDER_PAISE) {
          if (btn) { btn.removeAttribute('disabled'); btn.style.opacity = '1'; btn.innerHTML = originalText; }
          if (window.shiprocketCheckoutEvents && window.shiprocketCheckoutEvents.buyCart) {
            window.shiprocketCheckoutEvents.buyCart();
          }
        } else {
          if (btn) {
            btn.removeAttribute('disabled');
            btn.style.opacity = '0.5';
            btn.setAttribute('disabled', 'disabled');
            btn.innerHTML = originalText;
          }
          alert('Minimum order value is ₹249. Please add more items!');
        }
      })
      .catch(function (e) {
        if (window.console) console.error('Cart validation error:', e);
        if (btn) { btn.removeAttribute('disabled'); btn.style.opacity = '1'; btn.innerHTML = originalText; }
        alert('Something went wrong. Please try again.');
      });
  };

  // ============================================================
  // BLOCK C — Auto-close Shiprocket if cart qty changes mid-checkout
  // ============================================================
  function initShiprocketWatchers() {
    var srOpen = false;

    function closeShiprocket() {
      srOpen = false;
      try {
        var iframe = document.getElementById('headless-iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({ trigger: 'headless-close' }, '*');
        }
        var container = document.getElementById('fastrr-main-container');
        if (container) container.remove();
        document.body.style.overflow = 'auto';
      } catch (e) {}
      alert('Cart was changed. Minimum order is ₹249. Please try again.');
    }

    function watchQuantityInputs() {
      var inputs = document.querySelectorAll(
        'input[name="quantity"], input[id*="quantity"], input[id*="Quantity"], .quantity__input'
      );
      inputs.forEach(function (input) {
        if (input._srWatched) return;
        input._srWatched = true;
        input.addEventListener('keydown', function () { if (srOpen) setTimeout(closeShiprocket, 0); });
        input.addEventListener('input', function () { if (srOpen) setTimeout(closeShiprocket, 0); });
      });
    }

    function watchQtyButtons() {
      document.addEventListener('click', function (e) {
        if (!srOpen) return;
        var t = e.target;
        if (t.classList && t.classList.contains('quantity__button')) { setTimeout(closeShiprocket, 0); return; }
        if (t.name === 'minus' || t.name === 'plus') { setTimeout(closeShiprocket, 0); return; }
        if (t.closest && (t.closest('.quantity__button') || t.closest('[data-action="minus"]') || t.closest('[data-action="plus"]'))) {
          setTimeout(closeShiprocket, 0);
        }
      }, true);
    }

    var qtyObserver = new MutationObserver(function () { watchQuantityInputs(); });
    qtyObserver.observe(document.body, { childList: true, subtree: true });

    function hookShiprocket() {
      if (window.shiprocketCheckoutEvents && !window._srHooked) {
        window._srHooked = true;
        var orig = window.shiprocketCheckoutEvents.buyCart;
        window.shiprocketCheckoutEvents.buyCart = function () {
          var args = arguments, self = this;
          fetch('/cart.js', { cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (cart.total_price < MIN_ORDER_PAISE) {
                alert('Minimum order is ₹249. Please add more items!');
                return;
              }
              srOpen = true;
              watchQuantityInputs();
              watchQtyButtons();
              orig.apply(self, args);
            });
        };
      } else if (!window._srHooked) {
        setTimeout(hookShiprocket, 200);
      }
    }

    window.addEventListener('message', function (e) {
      if (e.data && e.data.trigger === 'headless-close') srOpen = false;
    });

    hookShiprocket();
  }

  // ============================================================
  // BLOCK D — Cart drawer progress bar (free gift @ ₹349, free delivery @ ₹449)
  // ============================================================
  function initProgressBar() {
    var GP = 34900, DP = 44900;

    function renderBar(cp) {
      var bar = document.getElementById('stk-progress-bar');
      if (!bar) return;
      if (!cp || cp <= 0) { bar.className = ''; return; }
      bar.className = 'stk-visible';

      var gd = cp >= GP, dd = cp >= DP;
      var gw = dd ? 77 : Math.min(77, Math.round(cp * 77 / GP));
      var rw = (gd && !dd) ? Math.min(23, Math.round((cp - GP) * 23 / (DP - GP))) : 0;
      var rend = gw + rw;

      var msg = dd
        ? '<span>&#x1F389;</span><span>You unlocked <strong>Free Gift + Free Delivery</strong>!</span>'
        : gd
          ? '<span>&#x1F69A;</span><span>Add <strong>&#x20B9;' + Math.ceil((DP - cp) / 100) + ' more</strong> for Free Delivery!</span>'
          : '<span>&#x1F381;</span><span>Add <strong>&#x20B9;' + Math.ceil((GP - cp) / 100) + ' more</strong> for a Free Gift Pack!</span>';

      var outer = bar.querySelector('.stk-track-outer');
      var track = bar.querySelector('[data-stktrack]');
      if (outer && track) {
        track.style.display = 'block';
        if (dd) {
          track.style.background = 'linear-gradient(to right,#22c55e 0%,#22c55e 100%)';
        } else if (gw > 0) {
          track.style.background = 'linear-gradient(to right,#16a34a 0%,#22c55e ' + gw + '%,#e53e3e ' + gw + '%,#e53e3e ' + rend + '%,#ddd8d3 ' + rend + '%)';
        } else {
          track.style.background = '#ddd8d3';
        }
        var d1 = outer.querySelector('[data-d="1"]'), d2 = outer.querySelector('[data-d="2"]');
        if (d1) d1.className = 'stk-dot ' + ((gd || dd) ? 'on' : 'nx');
        if (d2) d2.className = 'stk-dot ' + (dd ? 'on' : gd ? 'nx' : '');
      }

      bar.querySelector('.stk-msg').innerHTML = msg;
      bar.querySelector('.stk-labels').innerHTML =
        '<div class="stk-lbl ' + ((gd || dd) ? 'on' : 'nx') + '" style="left:77.7%;">&#x1F381; Free<br>Gift Pack<br>&#x20B9;349</div>' +
        '<div class="stk-lbl ' + (dd ? 'on' : gd ? 'nx' : '') + '" style="left:100%;">&#x1F69A; Free<br>Delivery<br>&#x20B9;449</div>';
    }

    function updateBar() {
      // FIX #11 — removed cache:'no-store'. Browser cache + cart:updated event handle freshness.
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { renderBar(c.total_price || 0); })
        .catch(function () {});
    }

    function injectBar() {
      if (document.getElementById('stk-progress-bar')) return;
      var drawer = document.querySelector('cart-drawer-items');
      if (!drawer) return;
      var bar = document.createElement('div');
      bar.id = 'stk-progress-bar';
      bar.innerHTML =
        '<div class="stk-msg"></div>' +
        '<div class="stk-track-outer">' +
          '<div data-stktrack style="display:block;height:10px;border-radius:99px;background:#ddd8d3;"></div>' +
          '<div class="stk-dot nx" data-d="1" style="position:absolute;top:50%;left:77.7%;transform:translate(-50%,-50%);"></div>' +
          '<div class="stk-dot" data-d="2" style="position:absolute;top:50%;left:100%;transform:translate(-50%,-50%);"></div>' +
        '</div>' +
        '<div class="stk-labels"></div>';
      drawer.parentNode.insertBefore(bar, drawer);
      updateBar();
    }

    var _t = null;
    var barObserver = new MutationObserver(function () {
      clearTimeout(_t);
      _t = setTimeout(function () {
        injectBar();
        if (document.getElementById('stk-progress-bar')) updateBar();
      }, 50);
    });
    barObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ============================================================
  // BOOT — run everything after DOM ready
  // ============================================================
  function boot() {
    setCheckoutButtonVisibility();
    waitForShiprocketAndUpdate();
    document.addEventListener('cart:updated', fetchAndUpdateCart);
    initShiprocketWatchers();
    initProgressBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/*
 * ============================================================
 * STK add-to-cart -> open drawer  (appended 2026)
 * Makes native /cart/add forms add via AJAX and slide the theme
 * cart drawer open, instead of navigating to the /cart page.
 * Isolated IIFE — does not touch the logic above.
 * ============================================================
 */
(function () {
  'use strict';

  function getDrawer() { return document.querySelector('cart-drawer'); }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.closest('product-form')) return;      // let Dawn handle its own product-forms
    var drawer = getDrawer();
    if (!drawer) return;                            // no drawer on page -> allow native submit

    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var btnHTML = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

    var fd = new FormData(form);
    var ids = (typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';
    fd.append('sections', ids);
    fd.append('sections_url', window.location.pathname);

    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    function restoreBtn() {
      if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.innerHTML = btnHTML; }
    }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {                              // sold out / error -> native submit shows the message
          restoreBtn();
          form.submit();
          return;
        }

        // Un-empty the drawer so it can display
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        // Update the header cart bubble from the add response (if present)
        try {
          if (res.data && res.data.sections && res.data.sections['cart-icon-bubble']) {
            var bubbleWrap = document.getElementById('cart-icon-bubble');
            if (bubbleWrap) {
              var pb = new DOMParser().parseFromString(res.data.sections['cart-icon-bubble'], 'text/html');
              var nb = pb.querySelector('.shopify-section') || pb.body.firstElementChild;
              if (nb) bubbleWrap.innerHTML = nb.innerHTML;
            }
          }
        } catch (err) {}

        // FIX (2026-07-10): the add-response section can be stale on the very first
        // add (empty cart -> 1 item), which made the drawer open blank. Instead we
        // pull the drawer contents FRESH from the server before opening — the same
        // reliable method Dawn uses for quantity changes. Guarantees the item shows.
        var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        fetch(cartUrl + '?section_id=cart-drawer')
          .then(function (r) { return r.text(); })
          .then(function (txt) {
            var doc = new DOMParser().parseFromString(txt, 'text/html');
            ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
              var target = document.querySelector(sel);
              var source = doc.querySelector(sel);
              if (target && source) target.replaceWith(source);
            });
          })
          .catch(function () { /* keep going — open anyway */ })
          .then(function () {
            if (typeof drawer.open === 'function') drawer.open();
            try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (err) {}
            restoreBtn();
          });
      })
      .catch(function () {                           // network fail -> native fallback
        restoreBtn();
        form.submit();
      });
  }, true);
})();
